import 'jquery-touch-events';
import 'lightcase';
import sweetalert from 'sweetalert';


export function configureLightcase() {
  jQuery(document).ready(function ($) {
    
    var resizeTimer;
    
    $(window).on('resize', function(e) {
      
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        
        $('iframe').css('width', '100%');
        
      }, 250);
      
    });
    
    var doc = document,
    md = new MobileDetect(window.navigator.userAgent),
    _shrink = 2,
    _force = true,
    _iWidth = $(window).width() - 250,
    _iHeight = $(window).height() - 250,
    changeWidth = false,
    changeMargins = false,
    _width = 800, _height = 500,
    _iframeWidth = 800,
    _iframeHeight = 500,
    counter = 0;
    
    if (md.mobile() !== "" && md.mobile() !== null) {
      _width = $(window).width() - 20;
      _height = $(window).innerHeight() + 60;
      _iframeHeight = _height - 250;
      
      var _iWidth = $(window).width() - 120;
      if (md.phone()) {
        _iWidth = $(window).width() - 90;
        
      }
      var _iHeight = $(window).innerHeight() - 30;
      _shrink = .75;
      _force = true;
      changeWidth = true;
      if (md.os() === "iOS") {
        changeMargins = true;
      }
      
    }
    
    $("a[data-rel^=lightcase]").lightcase({
      swipe: true,
      fullscreenModeForMobile: false,
      liveResize: true,
      maxWidth: 1250,
      maxHeight: 1000,
      width: _iWidth,
      height: _iHeight,
      showCaption: false,
      shrinkFactor: _shrink,
      forceWidth: true,
      fixedRatio: true,
      iframe: {
        width: _iWidth,
        height: _iHeight + 12,
      },
      onStart: {
        checkIfModalOpened: function(){
          if($('.v--modal-overlay').length){
            $('body').addClass('modal-is-opened');
            $('#lightcase-overlay').prependTo($('#modals-container'));
          }
        },
        setDownloadLink: function () {
          let downloadLink = $(this)[0].attributes['data-download-link'];
          $('.lightcase-icon-download').remove();
          if (downloadLink) {
            $('.lightcase-icon-close').after('<a href="' + downloadLink.nodeValue + '" class="lightcase-icon-download" download></a>')
          }
        },
        setSource: function() {
          let images = document.getElementById('lightcase-case').getElementsByTagName('img');

          if(images){
            let lightboxphoto = images[0];
            if (lightboxphoto) {
              let currSource = lightboxphoto.getAttribute('data-src');
              let timeStamp = new Date().getTime().toString();
              if(currSource.includes('blob:')){
                lightboxphoto.src = currSource;
              }else{
                lightboxphoto.src = currSource + '?t=' + timeStamp;
              }
            }
          }
        },
        setImageSize: function () {
          if (lightcase.getObjectData().type !== 'inline') {
            return;
          }
          
          let type = lightcase.getObjectData().type;
          let url = lightcase.getObjectData().url;
          let imgHolder = $(url).find('.image-holder')[0];
          let image;
          if (type === 'inline') {
            image = $(url).find('img')[0];
          }
          
          if (!image) {
            return false;
          }
          if ($(image)[0].naturalWidth - $(image)[0].naturalHeight > 50) {
            $(imgHolder).addClass('image-landscape');
          } else {
            $(imgHolder).removeClass('image-landscape');
          }
          
          $(image).on('load', function() {
            if ($(image)[0].naturalWidth - $(image)[0].naturalHeight > 50) {
              $(imgHolder).addClass('image-landscape');
            } else {
              $(imgHolder).removeClass('image-landscape');
            }
          });
          
          var degrees = 0;
          
          function rotateImage(direction) {
            var $lightboxphoto = $('#lightcase-case').children().find('img');
            
            if (direction === 'left') {
              degrees -= 90;
            } else {
              degrees += 90;
            }
            
            if (Math.abs(degrees) > 360) {
              degrees = degrees - 360;
            }
            
            if (Math.abs(degrees) === 360) {
              degrees = 0;
            }
            
            $($lightboxphoto).data('angle', degrees);
            $lightboxphoto.css('-ms-transform', 'rotate(' + degrees + 'deg)');
            $lightboxphoto.css('-webkit-transform', 'rotate(' + degrees + 'deg)');
            $lightboxphoto.toggleClass('rotated');
            if ($lightboxphoto.hasClass('rotated')) {
              if ($lightboxphoto[0].naturalWidth > $lightboxphoto[0].naturalHeight) {
                
                if ($(imgHolder).height() < $(imgHolder).width()) {
                  $lightboxphoto.css('max-height', 'none');
                  $lightboxphoto.css('max-width', $(imgHolder).height());
                }
                
              } else if ($lightboxphoto[0].naturalHeight > $lightboxphoto[0].naturalWidth) {
                if ($(imgHolder).width() < $(imgHolder).height()) {
                  $lightboxphoto.css('max-width', 'auto');
                  $lightboxphoto.css('max-height', $(imgHolder).width());
                }
              }
            }
            else {
              $lightboxphoto.css({
                'max-width': '100%',
                'max-height': '100%',
                'min-width': 0
              });
            }
          }
          
          $('.rotate').bind('click', function (event) {
            event.preventDefault();
            rotateImage();
          });
          $('.rotate-left').bind('click', function (event) {
            event.preventDefault();
            rotateImage('left');
          });
          $('.js-confirm-rotate-save').bind('click', function (event) {
            event.preventDefault();
            var $lightboxphoto = $('#lightcase-case').children().find('img');
            var data = $($lightboxphoto).data('angle');
            
            if (data) {
              let rotateUrl = lightcase.origin[0].attributes['data-rotate-url'].nodeValue;
              
              if (rotateUrl) {
                $.ajax({
                  url: rotateUrl,
                  method: 'put',
                  data: {angle: data },
                  success: (response) => {
                    sweetalert('Success', 'The data was updated!', 'success');
                    let thumbnail = lightcase.getObjectData().this[0].style['background-image'];
                    let url = thumbnail.substring(5, thumbnail.length - 2);
                    if(url.indexOf('250x250-resize')!==-1){
                      url=url.replace('large', 'small');
                    }
                    lightcase.getObjectData().this.css('background-image', '');
                    lightcase.getObjectData().this.css('background-image', 'url("' + url + '?t=1")');
                  },
                  error: () => {
                    
                  }
                });
              }
            }
            
          });
        },
        addClass(){
          $('body').addClass('is-preview-opened');
        },
        renderButtons: function () {
            var parent = this.closest('.v-gallery__thumbnail-wrap');

            $('.v-gallery__done--popup, .v-gallery__close--popup ').remove();

            if (parent.find(".v-gallery__done").length) {
                $('<span class="func-gallery-done-btn v-gallery__done v-gallery__done--popup" "><i class="material-icons">' + parent.find(".v-gallery__done .material-icons").text() + '</i></span>').appendTo("body");
            }
            if (parent.find(".v-gallery__close").length) {
                $('<span class="func-gallery-close-btn v-gallery__close v-gallery__close--popup"><i class="material-icons">cancel</i></span>').appendTo("body");
            }
        }
      },
      onBeforeCalculateDimensions : {
        setPrintButton: function () {
          if(!$('.lightcase-contentInner iframe').length && !$('.lightcase-contentInner .js-video').length){
            $('.js-lightcase-print-btn').remove();
            $('#lightcase-title').before('<button type="button" class="js-lightcase-print-btn lightcase-print-btn" title="Print this document">print</button>');
            $('.js-lightcase-print-btn').on('click', function () {
              window.print();
            });
          } else {
            $('.js-lightcase-print-btn').remove();
          }
        }
      },
      onFinish: {
        addZoomTools: function(){
          let $selector = '.js-lightcase-image',
          width = 0;
          
          counter = 0;
          
          $(document).off('click', '#zoomInIcon');
          $(document).off('click', '#zoomOutIcon');
          $(document).off('click', '#resetZoom');          
          
          $(document).on('click', '#zoomInIcon', function(e){
            e.preventDefault();
            
            let $parent = $(this).parents('.lightcase-holder');
            
            width = parseInt($parent.find($selector).find('img').width());
            
            width += 250;
            counter++;
            
            $parent.find($selector).find('img').css({
              'max-width': width,
              'min-width': width,
              'max-height': 'none'
            });
            
            
            $parent.find('#zoomOutIcon').removeClass('disabled');
            
            if(counter > 3){
              $(this).addClass('disabled');
              return;
            }
          });
          
          $(document).on('click', '#zoomOutIcon', function(e){
            e.preventDefault();
            
            let $parent = $(this).parents('.lightcase-holder');                
            width -= 250;
            counter--;
            
            $parent.find('#zoomInIcon').removeClass('disabled');
            
            $parent.find($selector).find('img').css(
              {
                'min-width': width,
                'max-width': width
              });
              
              if (counter <= 0){
                $(this).addClass('disabled');
                
                $parent.find($selector).find('img').css({
                  'max-width': '100%',
                  'max-height': '100%',
                  'min-width': 0
                });
                
                return;
              }
            });
            
          $(document).on('click', '#resetZoom', function(e){
              e.preventDefault();
              let $parent = $(this).parents('.lightcase-holder');
              
              $parent.find($selector).find('img').removeAttr('style');
              
              $parent.find('#zoomInIcon').removeClass('disabled');
              $parent.find('#zoomOutIcon').addClass('disabled');
              width = 0;
              counter = 0;
            });
          },
          addTools: function(){
            $('.v-gallery__thumbnail-wrap').removeClass('is-clicked-to-preview');
              this.closest('.v-gallery__thumbnail-wrap').addClass('is-clicked-to-preview');
          }
        },
      onClose: {
          clean: function() {
            $('body').removeClass('is-preview-opened modal-is-opened');
            $('.v-gallery__thumbnail-wrap').removeClass('is-clicked-to-preview');
            $('.js-lightcase-print-btn').remove();
            $('#lightcase-overlay').appendTo('body');
            $('.v-gallery__done--popup, .v-gallery__close--popup ').remove();
            counter = 0;
          }
        }
      });
      
      
      $(document).on('click', '.v-gallery__thumbnail', function (e) {
        if (e.originalEvent !== undefined) {
          let $item = $(this).closest('.v-gallery__thumbnail-wrap');
          
          $item.removeClass('is-clicked-to-preview');
          
          if($item.find('.v-gallery__done').length || $item.find('.v-gallery__close').length){
            $item.addClass('is-clicked-to-preview');
          }
        }
      });
    });
    
  };
  
  export default configureLightcase;


// WEBPACK FOOTER //
// ./resources/js/lightcase.js